module.exports = __webpack_public_path__ + "static/rls-thankyou-36d7d87b6edee74ac14dbd4559908fea.jpeg";